import React from "react";

const TradeArrowUpIcon = ({ className, size = 20, color = "#21B45F", ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    aria-hidden="true"
    {...props}
  >
    <path
      d="M3.72495 10.4417C3.48079 10.1975 3.48079 9.80164 3.72495 9.55747L9.55829 3.72414C9.80245 3.47997 10.1983 3.47997 10.4425 3.72414L16.2758 9.55747C16.52 9.80164 16.52 10.1975 16.2758 10.4417C16.1542 10.5633 15.9941 10.625 15.8341 10.625C15.6741 10.625 15.5141 10.5642 15.3924 10.4417L10.0008 5.05003L4.60915 10.4417C4.36415 10.6858 3.96912 10.6858 3.72495 10.4417ZM10.4417 9.55829C10.1975 9.31412 9.80164 9.31412 9.55747 9.55829L3.72414 15.3916C3.47997 15.6358 3.47997 16.0317 3.72414 16.2758C3.96831 16.52 4.36417 16.52 4.60834 16.2758L9.99998 10.8842L15.3916 16.2758C15.5133 16.3975 15.6733 16.4591 15.8333 16.4591C15.9933 16.4591 16.1533 16.3983 16.275 16.2758C16.5192 16.0317 16.5192 15.6358 16.275 15.3916L10.4417 9.55829Z"
      fill={color}
    />
  </svg>
);

export default TradeArrowUpIcon;
